var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Quitter",
    transform: "translate(0.869 0.869)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oval",
    d: "M33-.5A33.509,33.509,0,0,1,46.04,63.867,33.509,33.509,0,0,1,19.96,2.133,33.291,33.291,0,0,1,33-.5Zm0,66A32.509,32.509,0,0,0,45.65,3.054a32.509,32.509,0,0,0-25.3,59.892A32.3,32.3,0,0,0,33,65.5Z",
    transform: "translate(-0.369 -0.369)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(24.044 24.044)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_6",
    "data-name": "Line 6",
    d: "M16.815,17.522-.707,0,0-.707,17.522,16.815Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_7",
    "data-name": "Line 7",
    d: "M0,17.522l-.707-.707L16.815-.707,17.522,0Z",
    transform: "translate(0 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuitter);
export default __webpack_public_path__ + "static/media/Quitter.b59ea85932c9223613048a7a355f6448.svg";
export { ForwardRef as ReactComponent };